﻿/*
 * 文件名: sso.js
 * 描述: 提供对 CAS 单点登录的封装
 *
 * 功能说明：
 * 实现多个应用之间的单点登录（SSO）功能，应用可以部署在不同的域名。
 *
 * 版本: 1.0.0.1
 * 作者: jhzhang@iflytek.com
 * 日期：2013/10/20
 */


/**
* @param serviceUrl - 应用部署地址，PHP 网站请使用 ssoservice.php 所在 Url，
*   JAVA 网站对应 ssoservice.jsp 所在 Url，否则需要自己处理单点登出事件。
* @param casUrl - CAS 认证中心地址
**/
import $ from 'jquery';
//获取iplat路径
function getIplatPath() {
    return getHostPath() + "/iplat";//线上接口
}
//获取主机url
function getHostPath() {
    var curWwwPath = window.document.location.href;
    var pathName = window.document.location.pathname;
    var pos = curWwwPath.indexOf(pathName);
    var localhostPath = curWwwPath.substring(0, pos);
    return localhostPath;
}

// 获取参数值
function getQueryVariable(variable){
	console.log(window.location);
	//var query = window.location.href;
	if(window.location.href.indexOf('service=') != -1){
	   var arr = window.location.href.split('service=');   
	   if(arr[1].indexOf('&') == -1){
		   return unescape(arr[1]);
	   }
	   var arr2 = arr[1].split('&');
	   var jm= unescape(arr2[0]);
	   return jm?jm:''  
	}else{
	   var vars = window.location.href.split("&");
	   for (var i=0;i<vars.length;i++) {
			   var pair = vars[i].split("=");
			   if(pair[0] == variable){return pair[1];}
	   }
	   return(false);
	}
}

function EduSSO(serviceUrl, casUrl){

  var _this = this;
  this._casUrl = casUrl;
  this._serviceUrl = serviceUrl; //'http://www.meixuego.com/iplat/ssoservice';

  this._callback = function(callback, data) {
    if (typeof(callback) == "function"){
        callback(data);
    }
  }

  this._type = function(o) {
      var _toS = Object.prototype.toString;
      var _types = {
          'undefined': 'undefined',
          'number': 'number',
          'boolean': 'boolean',
          'string': 'string',
          '[object Function]': 'function',
          '[object RegExp]': 'regexp',
          '[object Array]': 'array',
          '[object Date]': 'date',
          '[object Error]': 'error'
      };
      return _types[typeof o] || _types[_toS.call(o)] || (o ? 'object' : 'null');
  };
  this._evalJSON = function(s) {
      if (this._type(s) != 'string' || !s.length) return null;
      return eval('(' + s + ')');
  };

  function realCasLogin (callback, params, retry,a,b,c) {
    if(null==params.lt || ''==params.lt){
    	flushLoginTicket(callback,params,retry,true);
    	$.ajaxSettings.async=false;
    }
	// var base = require("js-base64").Base64;
	// params.username = $.trim($('#username').val());
    // params.password = base.encode($('#password').val());
	params.x_code = c;

    var loginURL = _this._casUrl + "/login?service=" + encodeURIComponent(_this._serviceUrl);
	$.ajaxSettings.async=false;
    $.ajax({
        url: loginURL,
        dataType: "jsonp",
	    crossDomain: true,
		async: false,
		jsonpCallback: "logincallback",
        data: params,
		success: function (data) {//登录成功
        	if (data.login == 'fails') {
        		var resultobj = {result: "fail", code: "1002", data: data.msgCode};
                _this._callback(callback, resultobj);
                return;
        	}
        	$.ajaxSettings.async=false;
        	var service = getQueryVariable("service");
					// if(service != "") {
					// 	var url= service   
                    //     location.href = url;
                    //     return;
					// }
        	customLoginCallBack(callback,params,data);
        	let loginLock = false;
        },
		error: function (data) {//登陆失败
        	var resultobj = {result: "fail", code: "-1", data: data.msgCode};
            _this._callback(callback, resultobj);
        }
    });
  }

//先获取要登录的验证信息
  function flushLoginTicket (callback,params,retry,doLogin) {
	if(null==params)
		var params = {};
		var urlStr =  _this._casUrl + '/login?&get-lt=true&n=' + new Date().getTime();
		$.ajax({
			url: urlStr,
			dataType: "jsonp",
		    crossDomain: true,
			async: false,
			jsonpCallback: "jsonpcallback",
			success: function (data) {
				params.lt = data.lt;
				params.execution = data.execution;
				if (doLogin) {
					$.ajaxSettings.async=false;
				    realCasLogin(callback, params, retry);
				}
			},
			error: function (err) {
				return;
			}
		});
	}


  function customLoginCallBack(callback,params,result) {
	 	var pl = {};
	    pl.action = "login";
	    $.ajax({
	        url: _this._serviceUrl,
	        type: "POST",
	        data: pl,
	        dataType: "jsonp",
	        crossDomain: true,
	        cache: false,
	        async: false,
	        success: function (html) {
	            html = $.trim(html).replace(/\t/g, '');
	            var resultobj = {};
	            resultobj.result = "success";
	            resultobj.code = 3001;
	            resultobj.data = html;
	            _this._callback(callback, resultobj);
	        },
	        error: function (html) {
             /*   location.reload();*/
	        	html = $.trim(html).replace(/\t/g, '');
	            var resultobj = {};
	            resultobj.result = "success";
	            resultobj.code = 3001;
	            resultobj.data = html;
	            _this._callback(callback, resultobj);
	        }
	    });
	}
  /**
  * 用户登录
  * @param username - 用户名
  * @param password - 密码
  * @param key - `login_name`, `email`, `mobile`
  **/
 // this.casUrl  "https://cycore.fifedu.com/cas-server";
  this.login = function(appname, sourceappname, methodkey, username, password, uuid, callback){
    var loginURL = _this._casUrl + "/login?service=" + encodeURIComponent(_this._serviceUrl)
					 + '&get-lt=true&n=' + new Date().getTime();
	var base = require("js-base64").Base64;
	var params = {};
	params.username = username;
	params.password = Base64.encode(password);
    params.isajax = true;
    params.isframe = true;
    params._eventId = 'submit';
    params.serviceURL ='';
    params.lt='';
    params.type = 'pwd';
    $.ajax({
		url: loginURL,
		dataType: "jsonp",
		async: false,
		crossDomain: true,
		jsonpCallback: "jsonpcallback",
		success: function (data) {
			console.log(data);
			params.lt= data.lt;
			params.execution = data.execution;
			realCasLogin(callback, params, null,username,password,uuid);
		},
		error: function (err) {
			console.log(err,'登录失败')
			location.href = getIplatPath()+'/html/index.html';
		}
	});
  }

  this._serviceLogin = function(callback, serviceTicket, tgt) {
	    var pl = {};
	    pl.action = "login";
	    $.ajax({
	        url: _this._serviceUrl+'?ticket=',
	        type: "POST",
	        data: pl,
	        //dataType: "jsonp",
	        cache: false,
	        success: function (html) {
	            html = $.trim(html).replace(/\t/g, '');
	            var resultobj = {};
	            resultobj.result = "success";
	            resultobj.code = 3001;
	            resultobj.data = html;
	            _this._callback(callback, resultobj);
	        },
	        error: function (data) {
	            var resultobj = {result: "fail", code: "-1", data: "密码输入错误，请重新输入！"};
	            _this._callback(callback, resultobj);
	        }
	    });
	  }

  /**
  * 用户登出一般总是返回成功
  **/
  this.logout = function(callback) {
	var pl = {};
	pl.action = "logout";
    $.ajax({
        url: _this._serviceUrl,//shiro logout
        type: "POST",
        data: pl,
        cache: false,
        success: function (html) {
    	 	var logoutURL = _this._casUrl + "/logout";//cas logout
    	    $.ajax({
    	        url: logoutURL,
    	        dataType: "jsonp",
    			async: false,
    			jsonpCallback: "logoutcallback",
    	        success: function (data) {
    	            if (data.logoutStatus == "SUCCESS") {
    	            	 html = $.trim(html).replace(/\t/g, '');
    	                 var resultobj = {};
    	                 resultobj.result = "success";
    	                 resultobj.code = 4001;
    	                 resultobj.data = html;
    	            }
    	        	_this._callback(callback, resultobj);
    	        },
    	        error: function (data) {
					location.href = getIplatPath()+"/fifLogin/index.html?v=5.3";
    	        }
    	    });
        },
        error: function (data) {
			location.href =getIplatPath()+"/fifLogin/index.html?v=5.3";
        }
    });
  }

  //shiro logout
  this._serviceLogout = function(callback) {
    var pl = {};
    pl.action = "logout";
    $.ajax({
        url: _this._serviceUrl,
        type: "POST",
        data: pl,
        cache: false,
        success: function (html) {
            html = $.trim(html).replace(/\t/g, '');
            var resultobj = {};
            resultobj.result = "success";
            resultobj.code = 4001;
            resultobj.data = html;

            _this._callback(callback, resultobj);
        },
        error: function (data) {
        	location.href = getIplatPath()+"/fifLogin/index.html?v=5.3";
        }
    });
  }

  //cas logout
  this.casLogout = function(callback) {
    var logoutURL = _this._casUrl + "/logout";//cas logout
	$.ajax({
		url: logoutURL,
		dataType: "jsonp",
		async: false,
		jsonpCallback: "logoutcallback",
		success: function (data) {
			
		},
		error: function (data) {
			
		}
	});
  }

}
export {EduSSO}



//////////////////
// WEBPACK FOOTER
// ./static/utils/sso.js
// module id = ZnOo
// module chunks = 1 2 3 4